import { render } from "./CustomIconButton.vue?vue&type=template&id=710adaca&scoped=true"
import script from "./CustomIconButton.vue?vue&type=script&lang=js"
export * from "./CustomIconButton.vue?vue&type=script&lang=js"

import "./CustomIconButton.vue?vue&type=style&index=0&id=710adaca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710adaca"]])

export default __exports__